export function PsychologicalTrigger() {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Most Business Websites Are<br />Losing Customers Every Day
          </h2>
          <div className="w-24 h-1 bg-teal-500 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Your website might be costing you more than you think. Here's what's happening behind the scenes.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            { icon: 'ri-time-line', title: 'Slow Loading', desc: 'Visitors leave before your site even loads' },
            { icon: 'ri-smartphone-line', title: 'Poor Mobile Experience', desc: 'Most customers browse on phones' },
            { icon: 'ri-search-line', title: 'Weak Search Visibility', desc: 'Competitors appear first in search results' },
            { icon: 'ri-arrow-right-line', title: 'Weak Call-to-Actions', desc: 'Visitors don\'t know what to do next' }
          ].map((item, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all border border-gray-100 hover:border-teal-500"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-red-500 to-orange-500 rounded-xl flex items-center justify-center mb-4">
                <i className={`${item.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-red-50 to-orange-50 rounded-2xl p-8 border-l-4 border-red-500">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-alert-line text-white text-xl"></i>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">The Hidden Cost</h3>
              <p className="text-lg text-gray-700">
                Every day your website underperforms, potential customers are choosing your competitors instead. 
                An outdated or poorly optimized website doesn't just fail to attract customers—it actively pushes them away.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}